import { colors } from './colors';
import { fonts } from './fonts';
export var typographyStyles = {
    H1: {
        fontSize: [28, 30, 32, 34],
        margin: 10,
        color: colors.primary,
        fontFamily: fonts.main,
        as: 'h1',
    },
    H2: {
        fontSize: [20, 22, 28, 30],
        margin: 10,
        color: colors.primary,
        fontFamily: fonts.main,
        as: 'h2',
    },
    H3: {
        fontSize: [20, 22, 24, 26],
        margin: 10,
        color: colors.primary,
        fontFamily: fonts.secondary,
        as: 'h3',
    },
    H4: {
        fontSize: [16, 18, 20, 22],
        margin: 10,
        color: colors.primary,
        fontFamily: fonts.secondary,
        as: 'h4',
    },
    H5: {
        fontSize: [12, 15, 18, 20],
        margin: 10,
        color: colors.primary,
        fontFamily: fonts.secondary,
        as: 'h5',
    },
    LargeLead: {
        margin: 5,
        fontSize: [14, 16, 18, 20],
        color: colors.primary,
        fontFamily: fonts.main,
        as: 'p',
    },
    SmallLead: {
        margin: 5,
        fontSize: [12, 14, 16, 18],
        color: colors.primary,
        fontFamily: fonts.secondary,
        as: 'p',
    },
    Paragraph: {
        fontSize: [12, 12, 16, 18],
        fontFamily: fonts.secondary,
        color: colors.primary,
        as: 'p',
        margin: 0,
    },
    SmallParagraph: {
        fontSize: [13, 12, 14, 15],
        fontFamily: fonts.secondary,
        color: colors.primary,
        as: 'p',
    },
    Link: {
        color: colors.link,
        fontSize: [14, 12, 15, 16],
        fontFamily: fonts.secondary,
    },
};
